import { MockDebug } from '@tino-frontend/mocks'

import {
  creditLimitAvailableAPIMock,
  creditLimitBlockedAPIMock,
  creditLimitUsedAPIMock,
  creditLimitRejectAPIMock,
  creditLimitUndefinedAPIMock,
} from '@fixtures/apis/user/credit-limit'

import {
  REACT_APP_CORE_API_URL,
  REACT_APP_MERCHANT_BFF_API_URL,
} from 'constants/envs'

const MockDebugCreditLimit: MockDebug = {
  title: 'credit-limit',
  path: `${REACT_APP_CORE_API_URL}/me/companies/:documentType/:documentNumber/credit-limit`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-creditLimit-used',
      title: 'used',
      status: 200,
      data: creditLimitUsedAPIMock(),
    },
    {
      id: 'mock-creditLimit-undefined',
      title: 'undefined',
      status: 200,
      data: creditLimitUndefinedAPIMock(),
    },
    {
      id: 'mock-creditLimit-reject',
      title: 'reject',
      status: 200,
      data: creditLimitRejectAPIMock(),
    },
    {
      id: 'mock-creditLimit-blocked',
      title: 'blocked',
      status: 200,
      data: creditLimitBlockedAPIMock(),
    },
    {
      id: 'mock-creditLimit-available',
      title: 'available',
      status: 200,
      data: creditLimitAvailableAPIMock.source,
    },
    {
      id: 'mock-creditLimit-error',
      title: 'error',
      status: 500,
      data: undefined,
    },
  ],
}

// Service: credit limit
const MockDebugRaisedCreditLimit: MockDebug = {
  title: 'raise-credit-limit',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/request-raise-limit`,
  method: 'post',
  delay: 3000,
  options: [
    {
      id: 'mock-raise-credit-limit',
      title: 'Raise Request',
      status: 200,
      data: {},
    },
  ],
}

export const MockDebugCreditLimitSituation = [
  MockDebugCreditLimit,
  MockDebugRaisedCreditLimit,
]
